import { render, staticRenderFns } from "./tmOptionalAudioInsertMenu.vue?vue&type=template&id=3ac5bbf7&"
import script from "./tmOptionalAudioInsertMenu.vue?vue&type=script&lang=js&"
export * from "./tmOptionalAudioInsertMenu.vue?vue&type=script&lang=js&"
import style0 from "./tmOptionalAudioInsertMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports